import Vue, {CreateElement} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ja";
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import vuetify from "./plugins/vuetify";
import PortalVue from "portal-vue";
import customElementUI from "./element-ui-custom";

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(PortalVue);

customElementUI();

new Vue({
  router,
  store,
  vuetify,
  render: (h: CreateElement) => h(App),
}).$mount('#app');
